module.exports = __webpack_public_path__ + "LY.png?1ddc328f6de189ef689267149a00832c";